import { render, staticRenderFns } from "./add_to_cart_light.vue?vue&type=template&id=74843cd9&lang=html&"
import script from "./add_to_cart_light.vue?vue&type=script&lang=js&"
export * from "./add_to_cart_light.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports